'use client';
import { useCallback, useEffect, useRef, useState } from 'react';

import Tooltip from '../../tooltip/tooltip';
import styles from './onBoardingTipItem.module.scss';
import cn from 'classnames';

export const OnBoardingTipItem = ({
  isShown,
  hideTooltip,
  saveStorage,
}: {
  isShown: boolean;
  hideTooltip: () => void;
  saveStorage: () => void;
}) => {
  const tooltipRef = useRef<HTMLDivElement>(null);
  const infoRef = useRef<HTMLDivElement>(null);
  const filterRef = useRef<HTMLDivElement>(null);
  const [tooltipIndex, setTooltipIndex] = useState<number>(0);

  const showInfoTolltip = () => {
    const elementRect = infoRef.current?.getBoundingClientRect();
    tooltipRef.current?.dispatchEvent(
      new CustomEvent('tooltipOpened', {
        detail: {
          title: null,
          description: "See fabric information",
          topPosition: elementRect?.top,
          leftPosition: elementRect?.left,
          width: elementRect?.width
        },
        bubbles: true,
      })
    )
  }

  const showFilterTooltip = () => {
    const elementRect = filterRef.current?.getBoundingClientRect();
    filterRef.current?.dispatchEvent(
      new CustomEvent('tooltipOpened', {
        detail: {
          title: null,
          description: "Filter fabrics by colour, season, etc.",
          topPosition: elementRect?.top,
          leftPosition: elementRect?.left,
          width: elementRect?.width
        },
        bubbles: true,
      })
    )
  }

  const closeCallbackFC = () => {
    if(tooltipIndex === 1) {
      setTooltipIndex(0);
      setTimeout(() => {
        setTooltipIndex(2);
        showFilterTooltip();
      }, 500);
    } else if(tooltipIndex === 2){
      hideTooltip();
      saveStorage();
    }
  }

  const adjustTooltip = useCallback(() => {
    if(tooltipIndex === 1) {
      showInfoTolltip();
    } else if(tooltipIndex === 2) {
      showFilterTooltip();
    }
  }, [tooltipIndex])

  useEffect(() => {
    window.addEventListener('resize', adjustTooltip);

    return () => {
      window.removeEventListener('resize', adjustTooltip);
    };
  }, [adjustTooltip]);

  useEffect(() => {
    if(isShown) {
      setTooltipIndex(1);
      showInfoTolltip();
    }
  }, [isShown]);

  return (
    <>
      {isShown &&
        <div ref={tooltipRef} className={styles.onBoardingTipsContainer}>
          <Tooltip noResizeClosing={true} closeCallbackFC={closeCallbackFC} isSingleLineText={true} />
          <div
            className={cn(styles.infoIconContainer, {[styles.isShown]: tooltipIndex === 1})}
            ref={infoRef}
            data-test-id="onboarding-tooltip-info"
          >
            <i className="susu-icons" translate="no">
              info
            </i>
          </div>
          <div
            className={cn(styles.filterContainer, {[styles.isShown]: tooltipIndex === 2})}
            ref={filterRef}
            data-test-id="onboarding-tooltip-filter"
          >
            <i className="susu-icons" translate="no">
              filter
            </i>
            <span>Filter</span>
          </div>
        </div>
      }
    </>
  );
};
